import {
  BARBER_PROFILE_ROUTE,
  BARBER_BOOKING_SLOT_ROUTE,
  BARBER_WAITING_LIST_START_ROUTE,
  BARBER_WAITING_LIST_END_ROUTE,
  BARBER_WAITING_LIST_CONFIRMATION_ROUTE,
  BARBER_WAITING_LIST_SUCCESS_ROUTE,
  BARBER_BOOKING_CALLOUT_ADDRESS_ROUTE,
  BARBER_BOOKING_CONFIRMATION_ROUTE,
  BARBER_BOOKING_PROMOTION_ROUTE,
  BARBER_BOOKING_SUCCESS_ROUTE,
} from './routeConstants';

export const getProfileRoute = (username) => {
  return BARBER_PROFILE_ROUTE.replace(':username', username);
};

export const getBarberBookingSlotRoute = (username) => {
  return BARBER_BOOKING_SLOT_ROUTE.replace(':username', username);
};

export const getBarberWaitingListStartRoute = (username) => {
  return BARBER_WAITING_LIST_START_ROUTE.replace(':username', username);
};

export const getBarberWaitingListEndRoute = (username) => {
  return BARBER_WAITING_LIST_END_ROUTE.replace(':username', username);
};

export const getBarberWaitingListConfirmationRoute = (username) => {
  return BARBER_WAITING_LIST_CONFIRMATION_ROUTE.replace(':username', username);
};

export const getBarberWaitingListSuccessRoute = (username) => {
  return BARBER_WAITING_LIST_SUCCESS_ROUTE.replace(':username', username);
};

export const getBarberBookingCalloutRoute = (username) => {
  return BARBER_BOOKING_CALLOUT_ADDRESS_ROUTE.replace(':username', username);
};

export const getBarberBookingConfirmationRoute = (username) => {
  return BARBER_BOOKING_CONFIRMATION_ROUTE.replace(':username', username);
};

export const getBarberBookingPromotionRoute = (username) => {
  return BARBER_BOOKING_PROMOTION_ROUTE.replace(':username', username);
};

export const getBarberBookingSuccessRoute = (username, bookingId) => {
  const route = BARBER_BOOKING_SUCCESS_ROUTE.replace(':username', username);
  return route.replace(':bookingId', bookingId);
};
